import React from 'react'

// Page-specific schemas based on Ishan Service Schema document

// Home Page Schema
export const HomePageSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Ishan Tech - Cloud & Data Center Services",
        "url": "https://ishantechnologies.com",
        "description": "Leading provider of cloud computing, data center, and network services in India",
        "potentialAction": {
            "@type": "SearchAction",
            "target": "https://ishantechnologies.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
        }
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// About Us Schema
export const AboutUsSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "About Ishan Tech",
        "url": "https://ishantechnologies.com/about-us",
        "description": "Learn about Ishan Tech's mission, vision, and commitment to providing world-class technology solutions"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Cloud Services Schema
export const CloudServicesSchema = () => {
    const schema = { 
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Expert Cloud Management Across AWS, Azure, GCP, and Oracle",
        "description": "Discover top-tier managed cloud services from AWS, Microsoft Azure, GCP, and Oracle. Boost your business with reliable, scalable, and secure cloud solutions.",
        "url":  "https://ishantechnologies.com/data-center-services/cloud-services",
        "provider": {
            "@type": "Organization",
            "name": "Ishan Technologies",
            "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

export const CloudPlansSchema = () => {
    const schema = {
        "@context":"https://schema.org",
        "@type":"Service","name":"Saksham Cloud Storage Plans for your Business",
        "description":"Explore Saksham cloud storage plans with compute-optimised, memory-optimised VPS, secure cloud object storage, and cloud server plans for all workloads.",
        "url":"https://ishantechnologies.com/cloud/plans",
        "provider":{
            "@type":"Organization",
            "name":"Ishan Technologies",
            "url":"https://ishantechnologies.com/"     
        },
        "image":"https://ishantechnologies.com/api/static/465261__banner_jpg.jpg"}
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Cloud Platform Schema
export const CloudPlatformSchema = () => {
    const schema = { 
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Ishan Sovereign Cloud: Secure, Scalable Cloud Solutions",
        "description": "Elevate your business with Ishan Technologies! Leading cloud platform providers offering hybrid cloud solutions for seamless performance & growth. Partner today!",
        "url": "https://ishantechnologies.com/data-center-services/cloud-platform",
        "provider": {
            "@type": "Organization",
            "name": "Ishan Technologies",
            "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Colocation Schema
export const ColocationSchema = ({ location, image, address }) => {
    console.log("Generating Colocation Schema for location:", location);
    const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Ishan Technologies",
        "image": image,
        "@id": "",
        "url": `https://ishantechnologies.com/colocation-service/${location.toLowerCase()}`,
        "telephone": "+91 28166-47426",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": address?.streetAddress,
          "addressLocality": address?.addressLocality,
          "postalCode": address?.postalCode,
          "addressCountry": "IN"
        }
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Network Services Schema
export const NetworkServiceSchema = () => {
    const schema = {
         "@context": "https://schema.org",
         "@type": "Service",
         "name": "Seamless Connectivity with Leading Network Providers",
         "description": "Empower your business with Ishan Technologies' high-speed broadband, enterprise connectivity & unified communications. Connect now for seamless solutions!",
          "url": "https://ishantechnologies.com/network-services",
         "provider": {
           "@type": "Organization",
           "name": "Ishan Technologies",
           "url": "https://ishantechnologies.com/"
         },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Systems Integration Schema
export const SystemsIntegrationSchema = () => {
    const schema = {
         "@context": "https://schema.org",
         "@type": "Service",
         "name": "Seamless System Integration for Digital Growth",
         "description": "Find your trusted system integrator near you! Ishan Technologies offers top-notch System Integration Services to boost efficiency & growth. Contact us today!",
          "url": "https://ishantechnologies.com/systems-integration",
         "provider": {
           "@type": "Organization",
           "name": "Ishan Technologies",
           "url": "https://ishantechnologies.com/"
         },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 

    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Cybersecurity Schema
export const CybersecuritySchema = () => {
    const schema = {
         "@context": "https://schema.org",
         "@type": "Service",
         "name": "Complete Cybersecurity for Threat Detection & Protection",
         "description": "Partner with Ishan Technologies for robust cybersecurity services, including IoT cybersecurity. We excel in managed services, audits, and compliance. Contact us now.",
          "url": "https://ishantechnologies.com/cybersecurity-services",
         "provider": {
           "@type": "Organization",
           "name": "Ishan Technologies",
           "url": "https://ishantechnologies.com/"
         },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Contact Schema
export const ContactSchema = ({ contactType, url }) => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": `Contact ${contactType}`,
        "url": url,
        "description": `Get in touch with Ishan Tech for ${contactType.toLowerCase()}`
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Careers Schema
export const CareersSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Careers at Ishan Tech",
        "url": "https://ishantechnologies.com/careers",
        "description": "Join our team and build your career in technology"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Events Schema
export const EventsSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Events & Updates",
        "url": "https://ishantechnologies.com/events",
        "description": "Stay updated with latest events and announcements from Ishan Tech"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Partners Schema
export const PartnersSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Our Partners",
        "url": "https://ishantechnologies.com/our-partners",
        "description": "Technology partners and strategic alliances"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Customers Schema
export const CustomersSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Our Customers",
        "url": "https://ishantechnologies.com/our-customers",
        "description": "Trusted by leading organizations across industries"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Apple Services Schema
export const AppleServicesSchema = ({ serviceName, url, description }) => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": serviceName,
        "url": url,
        "description": description,
        "provider": {
            "@type": "Organization",
            "name": "Ishan Tech"
        },
        "serviceType": "Apple Enterprise Services"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Dell Services Schema
export const DellServicesSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Dell Server & Storage Solutions",
        "url": "https://ishantechnologies.com/dell/server-storage",
        "description": "Enterprise Dell server and storage solutions",
        "provider": {
            "@type": "Organization",
            "name": "Ishan Tech"
        },
        "serviceType": "Server & Storage"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Internet Services Schema
export const InternetServicesSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Internet Services",
        "url": "https://ishantechnologies.com/internet-services",
        "description": "High-speed internet connectivity solutions",
        "provider": {
            "@type": "Organization",
            "name": "Ishan Tech"
        },
        "serviceType": "Internet Services"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Cloud Calculator Schema
export const CloudCalculatorSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": "Cloud Pricing Calculator",
        "url": "https://ishantechnologies.com/cloud/calculator",
        "description": "Calculate pricing for cloud services and infrastructure",
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web Browser"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Privacy Policy Schema
export const PrivacyPolicySchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Privacy Policy",
        "url": "https://ishantechnologies.com/privacy-policy",
        "description": "Ishan Tech privacy policy and data protection information"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Terms and Conditions Schema
export const TermsConditionsSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Terms and Conditions",
        "url": "https://ishantechnologies.com/terms-and-condition",
        "description": "Terms and conditions for using Ishan Tech services"
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}